import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { portfolioApi } from './api';
import { portfolioWords } from './strings/portfolio';

export function PortfolioLink() {
  const { isInternalAdmin } = useAuth();
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    // The Team has "Portfolios" in its links row; asking the server twice on
    // every page just to hide a duplicate link cost a request per load (UXWALK).
    if (isInternalAdmin) return;
    portfolioApi.list().then((rows) => setAvailable(rows.length > 0)).catch(() => setAvailable(false));
  }, [isInternalAdmin]);
  // Only for someone who has a portfolio (COHERE2 P1-19); the Team reaches the
  // page from its links row, where portfolios are created.
  return available && !isInternalAdmin ? <Link to="/portfolios">{portfolioWords.eyebrow}</Link> : null;
}
